var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkingSource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0118 21.4199C43.0118 27.8261 41.416 32.1345 35.1481 37.8916C35.0308 38.0011 21.838 49.2268 21.838 49.2268C21.838 49.2268 8.58982 37.8108 8.47247 37.7013C3.67948 33.4867 0.671875 27.8261 0.671875 21.4199C0.671875 9.72626 10.152 0.253906 21.838 0.253906C33.5317 0.253906 43.0118 9.72626 43.0118 21.4199Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9186 38.7938C31.6012 38.7938 39.4505 30.9445 39.4505 21.2619C39.4505 11.5793 31.6012 3.72998 21.9186 3.72998C12.236 3.72998 4.38672 11.5793 4.38672 21.2619C4.38672 30.9445 12.236 38.7938 21.9186 38.7938Z",
    fill: "#FF6A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5278 13.0181L25.6929 30.7658H17.9269L15.0957 13.0181H28.5278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.671875 0.253906)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkingSource);
export default __webpack_public_path__ + "static/media/drinking-source.e8c23bf406bef3d6cfdfe20fe14b8505.svg";
export { ForwardRef as ReactComponent };